import { Grid } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { Button, Dialog, Text, TextField } from "src/shared"

interface IOtpFormProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  onOtpChange: (val?: string) => void
  isLoading?: boolean
  error?: boolean
}

const OtpForm = ({
  open,
  error = false,
  isLoading = false,
  onClose,
  onOtpChange,
  onSubmit,
}: IOtpFormProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onOtpChange(e.target.value)
  }
  return (
    <Dialog open={open} onClose={onClose}>
      <Grid alignItems="center" rowGap={2} container flexDirection="column">
        <Text
          color={theme.palette.secondary.main}
          fontSize={24}
          lineHeight="31.65px"
          fontWeight={700}
        >
          Nhập mã OTP
        </Text>
        <TextField
          fullWidth
          onChange={handleChange}
          placeholder="Nhập mã OTP"
          error={!!error}
          helperText={!!error ? "Mã OTP không đúng!" : ""}
        />
        <Button loading={isLoading} disabled={isLoading} onClick={onSubmit}>
          Xác nhận
        </Button>
      </Grid>
    </Dialog>
  )
}

export default OtpForm
